import Head from 'next/head';
import React from 'react';

type HoneymoonDestinationHeadProps = {
  href: string;
  title: string;
  description: string;
};
const HoneymoonDestinationHead = (props: HoneymoonDestinationHeadProps): JSX.Element => {
  const { href, title, description } = props;

  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content="https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/logos/zola-heart-marine.png"
      />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="zola.com" />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary" />
      <link rel="canonical" href={href} />
    </Head>
  );
};

export default HoneymoonDestinationHead;
